import URI from 'urijs';
export const buildURI = function (baseURL, path) {
  let qsParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return URI(`${baseURL}${path}`).search(qsParams);
};